"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BindEquip',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      nowTime: Date.parse(new Date()) / 1000,
      statusArr: ['未弹出', '准备弹出', '已弹出', '有异物', '充电口有异常'],
      form: {},
      numInfo: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        device_status: '0',
        search_user_type: 0,
        page_num: 1
      }
    };
  },
  mounted: function mounted() {
    this.getStatNum();
    this.getList();
  },
  methods: {
    /**
     * 数量
     */
    getStatNum: function getStatNum() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, this.form);
      this.$get('agentapi/batterys_data_stat_num', listQuery).then(function (res) {
        _this.numInfo = res;
        if (_this.$refs.equip_table) _this.tableMaxH = window.innerHeight - _this.$refs.equip_table.$el.offsetTop - 85;
      });
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.device_status = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getStatNum();
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      if (this.sort_id_key && window.sort_id_key) listQuery.sort_id_key = window.sort_id_key;
      this.$get('agentapi/search/query_batterys', listQuery).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.page_num = res.page_num;
        if (_this2.total_device_num == 0) {
          for (var i in res.type_device_num) {
            _this2.total_device_num += res.type_device_num[i];
          }
          _this2.type_device_num = res.type_device_num;
        }
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 弹出设备
     */
    ejectEquip: function ejectEquip(row) {
      var _this3 = this;
      var cang_num = [];
      this.loadObj = this.$loading({
        lock: true,
        text: '弹出中~~~',
        spinner: 'el-icon-loading'
      });
      this.$post('agentapi/eject_baos', {
        zuo_sn: row.nowat_zuo_sn,
        cang_num: [row.nowat_cang_num]
      }).then(function (res) {
        _this3.loadObj.close();
        _this3.$message({
          message: '弹出成功',
          type: 'success'
        });
        row.status = 2;
      });
    }
  }
};